import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Dropdown, Form, Nav, OverlayTrigger, Row, Tab, Tooltip, } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { CAT, MAS, NAR, REC, REP_SEC, SUB } from "../../../../../shared/Data/typeDirs";
import { useSource } from "../../../sourceContext";
import { ChevronDown, ChevronUp } from 'react-feather'
import "../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/categorySelector.css"
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { langTypeMap } from "../../../../../shared/Data/langTypeMap";
import { useNotificationContext } from "../../../../revised_components/contextProviders/notificationContext";
import { ReportV2 } from "../../../../../shared/Objects/newReportObjects/report_v2";
import { Input } from '@mui/joy';

const CAT_LIST = [{ type: REP_SEC, label: 'SECTION' }, { type: MAS, label: 'GROUP' }, { type: CAT, label: 'CATEGORY' }, { type: SUB, label: 'SUBCATEGORY' }]
export function CategorySelector({
  name,
  idx
}) {

  const controls = useControl()
  const [selectedType, setSelectedType] = useState(false)
  const { [idx - 1]: previousBlock, [idx]: block } = controls
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  useEffect(()=>{setSelectedType(false)}, [readOnly])
  const source = useSource()
  const [blockNameStateBuffer, setBlockNameStateBuffer] = useState(false)
  useEffect(() => { setSelectedType(false) }, [block._id])
  useEffect(() => {
    if (blockNameStateBuffer === false) return
    let timeout_id = setTimeout(() => {
      controlReducer({ type: 'changed', idx, name: 'blockName', update: { blockName: blockNameStateBuffer } })
      setBlockNameStateBuffer(false)
    }, 200)
    return () => { clearTimeout(timeout_id) }
  })

  const blockName = useMemo(() => blockNameStateBuffer || block.blockName || '', [blockNameStateBuffer, block.blockName])
  const menuState = useMemo(() => {
    return {
      [REP_SEC]: source[REP_SEC].find(itm => itm._id === block[REP_SEC]),
      [MAS]: source[MAS].find(itm => itm._id === block[MAS]),
      [CAT]: source[CAT].find(itm => itm._id === block[CAT]),
      [SUB]: source[SUB].find(itm => itm._id === block[SUB]),
    }
  }, [block, source])
  const controlReducer = useControlReducer()

  function locateSourceEntry(_id, src) {
    return src.find(itm => itm._id === _id)
  }


  function setSelectedCategoryType(evt) {
    // console.log('setting category type in CategorySelector', evt.target.name, evt.currentTarget.name)
    if (evt.currentTarget.name === selectedType) return setSelectedType(false)
    setSelectedType(evt.currentTarget.name)
  }
  const categoryController = readOnly? [] : [
    <CategorySelectorTabs 
        selectedType={selectedType} 
        setSelectedType={setSelectedType} 
        setSelectedCategoryType={setSelectedCategoryType} 
      />,
      <Row className="g-0 category-selector-row">
        <CategoryMenu
          name={name}
          idx={idx}
          type={selectedType}
          source={source}
          block={block}
          controlReducer={controlReducer}
        />
      </Row>
  ]
  return  (
    <div className="category-selector-button-container">
      {categoryController}

      <Row className="g-0 category-selector-row category-title-row">
        <Col sm="3" className="category-title-section-col">
          <div className="category-section-text">
            {menuState[REP_SEC] && menuState[REP_SEC].getDisplayText()}
          </div>
        </Col>
        <Col sm="9" className="category-title-col">
          <div className="category-title">
            <span style={{ fontStyle: 'italic' }}>{menuState[SUB].fullNumber.slice(4)}</span>
            <Input
              readOnly={readOnly}
              className="block-name-control"
              placeholder="Block Name (Subcategory)"
              type="text"
              onChange={evt => setBlockNameStateBuffer(evt.target.value)}
              value={blockName} >
            </Input>
          </div>
        </Col>
      </Row>
    </div>
  )
}

function CategorySelectorButtons({ selectedType, setSelectedCategoryType }) {
  return (
    <Row className="g-0 category-selector-row button-row">
      <Col sm className="category-button-col">
        <Button className={`category-button ${selectedType === REP_SEC ? 'active-selection' : ''}`} variant="info" name={REP_SEC} onClick={setSelectedCategoryType}>
          SECTION{selectedType === REP_SEC ? <ChevronUp /> : <ChevronDown />}
        </Button>
      </Col>
      <Col sm className="category-button-col">
        <Button className={`category-button ${selectedType === MAS ? 'active-selection' : ''}`} variant="outline-info" name={MAS} onClick={setSelectedCategoryType}>
          GROUP{selectedType === MAS ? <ChevronUp /> : <ChevronDown />}
        </Button>
      </Col>
      <Col sm className="category-button-col">
        <Button className={`category-button ${selectedType === CAT ? 'active-selection' : ''}`} variant="outline-info" name={CAT} onClick={setSelectedCategoryType}>
          CATEGORY{selectedType === CAT ? <ChevronUp /> : <ChevronDown />}
        </Button>
      </Col>
      <Col sm className="category-button-col">
        <Button className={`category-button ${selectedType === SUB ? 'active-selection' : ''}`} variant="outline-info" name={SUB} onClick={setSelectedCategoryType}>
          SUBCATEGORY{selectedType === SUB ? <ChevronUp /> : <ChevronDown />}
        </Button>
      </Col>
    </Row>
  )
}

function CategorySelectorTabs({ selectedType, setSelectedType }) {
  return (
    <Row className="g-0 category-selector-row button-row">
      <Tab.Container >
        <Nav
          className={`category-selector-tabs ${selectedType ? 'tabs-open' : ''}`}
          activeKey={selectedType}
          variant="tabs"
          onSelect={(key) => {
            console.log('category selector tabs onselect', key)
            if (selectedType === key) {
              setSelectedType(false)
            } else {
              setSelectedType(key)
            }
          }}>
          {CAT_LIST.map((itm, itmIdx) => (
            <Nav.Item 
              key={itmIdx} 
              className={`category-selector-tab ${itm.type} ${selectedType === itm.type ? 'active' : ''}`} >
              <Nav.Link 
                className={`category-selector-tab-label ${itm.type} ${selectedType === itm.type ? 'active' : ''}`} 
                eventKey={itm.type}>
                {itm.label}
                {itm.type === selectedType ? <ChevronUp /> : <ChevronDown />}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Tab.Container>
    </Row>
  )
}

function CategoryMenu({ controls, block, type, source, controlReducer, name, idx }) {
  const [langType, setLangType] = useState(NAR)
  const [langDisplay, setLangDisplay] = useState('title')
  const [filteredSource, setFilteredSource] = useState(false)
  const [filter, setFilter] = useState('')
  const [recommendationIdx, setRecommendationIdx] = useState(false)
  const displayNotif = useNotificationContext()
  const { settings, setSettings } = useControlHeaderContext()
  // useEffect(() => { setFilteredSource(source) }, [source])
  const [requestLink, setRequestLink] = useState(false)
  useEffect(() => {
    if (requestLink) {
      scrollToThing(requestLink)
      setTimeout(() => setRequestLink(false))
    }
  }, [requestLink])

  useEffect(() => {
    filterSource(filter, source)
  }, [filter, source])

  useEffect(() => {
    setRecommendationIdx(false)
  }, [block[REC].length])

  function filterSource(value, src) {
    let newSource = {}
    for (let key in src) {
      if (key === 'imageMap') continue
      newSource[key] = src[key].filter(itm => {
        if ([REP_SEC, MAS, CAT, SUB].includes(itm.type)) return true
        // if(langDisplay === 'title') return false

        let displayText = `${itm.short} ${itm.content}`.toLowerCase()
        // console.log('made some display text', key, displayText, value, displayText.includes(value.toLowerCase()))
        return displayText.includes(value.toLowerCase())
      })
    }
    setFilteredSource(newSource)
  }

  const setClassificationToContents = useCallback((itm) => {

    const categoryOrder = [MAS, CAT, SUB]
    const categoryTypeIndex = categoryOrder.indexOf(itm.type)
    console.log('selected item from category list', itm, categoryTypeIndex)
    let update = { [itm.type]: itm._id, blockName: itm.type === SUB ? itm.content : block.blockName }

    if (~categoryTypeIndex) {
      let catsToClear = categoryOrder.slice(categoryTypeIndex + 1)
      for (let childType of catsToClear) {
        const sourceEntry = source[childType].find(
          itm => update[langTypeMap[itm.type].getParentKey()] === itm[langTypeMap[itm.type].getParentAddress()]
        )
        update[childType] = sourceEntry._id
        if (childType === SUB) update.blockName = sourceEntry.content
      }
    }
    controlReducer({ type: 'changed', name, idx, update })
    if ([REP_SEC, SUB].includes(itm.type)) {
    setTimeout(() => {
      controlReducer({ type: 'sort_blocks', sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source), name, idx, blockId: block._id })
      // setRequestLink(block._id)
      setSettings({ ...settings, sorted: true })
    }, 100)
    } else if (categoryOrder.includes(itm.type)) {
      setSettings({ ...settings, sorted: false })
    }
  }, [controlReducer, name, idx, settings, source, block])

  const selectLanguageEntry = useCallback((itm) => {
    let update

    if (itm.type === NAR) {
      update = { ...block[NAR], content: block[NAR].content + ' ' + itm.content }
    } else {
      if (recommendationIdx === false) {
        displayNotif('info', 'You must select a recommendation to add this language to.')
        return
      }
      update = [
        ...block[REC].slice(0, recommendationIdx),
        { ...block[REC][recommendationIdx], content: block[REC][recommendationIdx].content + ' ' + itm.content },
        ...block[REC].slice(recommendationIdx + 1)
      ]
    }
    controlReducer({ type: 'changed', idx, name, update: { [itm.type]: update } })
  }, [block, recommendationIdx, controlReducer, idx, name, displayNotif])

  const languageMenuEntries = useMemo(() => {
    if (!type) return
    return filteredSource[type].filter(itm =>
      !langTypeMap[type].getParentKey() ||
      itm[langTypeMap[type].getParentAddress()] === block[langTypeMap[type].getParentKey()]
    ).reduce((acc, cur, idx, arr) => {
      acc = acc || []
      // console.log('whats goin on', acc, cur, idx, arr)
      let subItems = type === SUB ? filteredSource[langType].filter(itm => itm[`_${SUB}`] === cur._id) : []
      return [...acc, cur, ...subItems]
    }, [])
  }, [type, filteredSource, langType, langDisplay, block, filter])


  return !type ? [] : (
    <div className="category-menu-container">
      {
        type !== SUB ? [] : (
          <>
            <Row className="g-0 category-filter-container">
              <Form.Control
                className="category-filter-control"
                type="text"
                onChange={(evt) => setFilter(evt.target.value)}
                value={filter}
                placeholder="Search Language"

              />
            </Row>
            <Row className="g-0 language-control-area">
              <Col sm={3} className="language-control-col" >
                <div className="lang-button-container">
                  <OverlayTrigger trigger={["hover"]} placement="top" overlay={<Tooltip>Work in Progress...</Tooltip>}>
                    <Button variant="info" disabled>Change Language File</Button>
                  </OverlayTrigger>
                </div>
              </Col>
              <Col sm={4} className="language-control-col" >
                <Row className="g-0">
                  <Form.Label>Language Type:</Form.Label>
                </Row>
                <Row className="g-0">
                  <Col>
                    <Form.Check
                      inline
                      type="radio"
                      name="lang-type"
                      value={NAR}
                      checked={langType === NAR}
                      onChange={(evt) => setLangType(evt.target.value)}
                      label="Narrative"
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      inline
                      type="radio"
                      name="lang-type"
                      value={REC}
                      checked={langType === REC}
                      onChange={(evt) => setLangType(evt.target.value)}
                      label="Recommendation"
                    />
                    {langType !== REC ? [] : (
                      <Dropdown onSelect={(key) => setRecommendationIdx(parseInt(key, 10))} style={{ display: 'flex' }}>
                        <Dropdown.Toggle variant="info" style={{ fontSize: 10, margin: 'auto' }}>
                          {recommendationIdx === false ? 'Select A Recommendation' : recommendationIdx + 1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {block[REC].map((itm, idx) => <Dropdown.Item eventKey={`${idx}`}>{idx + 1}</Dropdown.Item>)}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col sm={4} className="language-control-col">
                <Row className="g-0">
                  <Form.Label>Language Display</Form.Label>
                </Row>
                <Row className="g-0">
                  <Col sm={4}>
                    <Form.Check
                      inline
                      type="radio"
                      name="lang-display"
                      value="title"
                      checked={langDisplay === 'title'}
                      onChange={(evt) => setLangDisplay(evt.target.value)}
                      label="Title Only"
                    />
                  </Col>
                  <Col sm={4}>
                    <Form.Check
                      inline
                      type="radio"
                      name="lang-display"
                      value="partial"
                      checked={langDisplay === 'partial'}
                      onChange={(evt) => setLangDisplay(evt.target.value)}
                      label="Partial Language"
                    />
                  </Col>
                  <Col sm={4}>
                    <Form.Check
                      inline
                      type="radio"
                      name="lang-display"
                      value="full"
                      checked={langDisplay === 'full'}
                      onChange={(evt) => setLangDisplay(evt.target.value)}
                      label="Full Language"
                    />
                  </Col>
                  
                </Row>
              </Col>
            </Row>
          </>
        )
      }
      <Row className="category-list-area g-0">
        {languageMenuEntries.map((itm, idx) => (
          <div
            key={idx}
            className={`g-0 category-language-list-item ${ itm._id === block[itm.type]? 'category-selected':''} ${![SUB, CAT, MAS].includes(itm.type) ? 'lang' : 'category'}`}
            onClick={[REP_SEC, SUB, CAT, MAS].includes(itm.type) ? () => setClassificationToContents(itm) : () => selectLanguageEntry(itm)}
          >
            <Col sm="2" className="category-list-title">
              <span >
                {itm.type === REP_SEC ? `Section ${itm.number}:` :
                  [SUB, CAT, MAS].includes(itm.type) ? `${itm.fullNumber}: ` : `${itm.short} `}
              </span>
            </Col>
            <Col className="category-list-content">
              <span >
                {[REC, NAR].includes(itm.type) ? langDisplay === 'title' ? '' :
                  langDisplay === 'partial' ? itm.content.length > 50 ? `${itm.content.slice(0, 50)}...` :
                    itm.content : itm.content : itm.content
                }
              </span>
            </Col>
          </div>
        ))}
      </Row>
    </div>
  )
}

// {
//   [SUB, CAT, MAS].includes(itm.type) ? <><span className="category-list-title">{`${itm.fullNumber}: `}</span>{itm.content} </> :
//     <><span className="category-list-title">{`${itm.short}: `}</span> <span style={{display:'inline'}}>{itm.content}</span></>
// }

function getSubcategoryChangedData(subcategoryid, source, reportSection) {
  let subcategory = source[SUB].find(sub => sub._id === subcategoryid)
  let category = source[CAT].find(cat => cat._id === subcategory._categories)
  return {
    [REP_SEC]: reportSection,
    [SUB]: subcategory._id,
    [CAT]: category._id,
    [MAS]: category._mastercategories,
    blockName: subcategory.content
  }
}

function scrollToThing(blockId) {
  // blockNameTextRef.current.scrollIntoView()
  console.log('scrolling to block', blockId)
  // goToBlock(blockId)
  // history.replace({...history.location, hash:`#${blockId}`})
  document.getElementById(blockId).scrollIntoView({ behavior: 'smooth' })
  // window.scrollTo(0, top)
  // window.location = (""+window.location).replace(/#[A-Za-z0-9_]*$/,'')+ `#${blockId}`
}